<template>
  <EntitasForm mode="Tambah" module="Entitas"> </EntitasForm>
</template>

<script>
import EntitasForm from './form';

const EntitasAdd = {
  name: 'EntitasAdd',
  components: { EntitasForm },
};

export default EntitasAdd;
</script>
